/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import styles from './PushNotifications.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { Button } from '../../UI/Button/Button';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStore';
import { useApi } from '../../../hooks/useApi';
import { Input } from '../../UI/input/input';
import { useEffect, useState } from 'react';
import { FileInput } from '../../UI/FileInput/FileInput';
import cn from 'classnames';

interface PopupProps {
  onClose: () => void;
  update: () => void;
}

const PushNotificationsPopUP: React.FC<PopupProps> = observer(
  ({ onClose, update }) => {
    const store = useStores();
    const api = useApi();

    const [title, setTitle] = useState<string>('');
    const [body, setBody] = useState<string>('');
    const [targetType, setTargetType] = useState<'all' | 'csv_users'>('all');
    const [url, setUrl] = useState<string>('');

    const [file, setFile] = useState<File | null>(null);

    const [disable, setDisable] = useState<boolean>(true);

    const handleButtonClick = async () => {
      try {
        store.notificationsStore.showPreloader();

        const formData = new FormData();

        formData.append('title', title);
        formData.append('body', body);
        formData.append('target_type', targetType);
        formData.append('url', url);

        if (file && targetType === 'csv_users') {
          formData.append('file', file);
        }

        await api.pushNotifications.send(formData);

        update();
        onClose();

        store.notificationsStore.setNotifications('Успешно выполнено');
      } catch (e) {
        store.notificationsStore.setError('Ошибка при выполнении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    useEffect(() => {
      if (
        title &&
        body &&
        (targetType === 'all' || (targetType === 'csv_users' && file))
      ) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [title, body, targetType, file]);

    return (
      <>
        <div className={styles.container}>
          <div className={styles.form}>
            <Close className={styles.close} onClick={onClose} />
            <h3>Создание рассылки</h3>
            <div className={styles.line} style={{ marginBottom: 20 }} />

            <Input
              style={{ maxWidth: '90%' }}
              value={title}
              placeholder="Заголовок"
              textLabel="Заголовок"
              onChange={(event) => setTitle(event.target.value)}
            />
            <Input
              style={{ maxWidth: '90%' }}
              value={body}
              placeholder="Текст уведомления"
              textLabel="Текст уведомления"
              onChange={(event) => setBody(event.target.value)}
            />
            <Input
              style={{ maxWidth: '90%' }}
              value={url}
              placeholder="Ссылка"
              textLabel="Ссылка"
              onChange={(event) => setUrl(event.target.value)}
            />

            <div className={styles.category}>
              <div
                className={cn(styles.categoryName, {
                  [styles.categoryActive]: targetType === 'all',
                })}
                onClick={() => {
                  setTargetType('all');
                }}
              >
                Все
              </div>
              <div className={styles.separator} />
              <div
                className={cn(styles.categoryName, {
                  [styles.categoryActive]: targetType === 'csv_users',
                })}
                onClick={() => {
                  setTargetType('csv_users');
                }}
              >
                База
              </div>
            </div>

            {targetType === 'csv_users' && (
              <FileInput
                style={{ maxWidth: '90%' }}
                id="resume"
                textLabel="Прикрепите файл"
                accept=".csv"
                onChange={(e) => {
                  const selectedFile = e.target.files?.[0] || null;
                  setFile(selectedFile);
                }}
              />
            )}

            <div className={styles.line} style={{ marginBottom: 10 }} />

            <div
              style={{
                display: 'flex',
                width: '90%',
                justifyContent: 'center',
              }}
            >
              <Button
                disabled={disable}
                onClick={handleButtonClick}
                style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                appearance="auth"
              >
                Создать
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default PushNotificationsPopUP;
